import React from 'react';

/**
 * LogoTile - Central component for displaying the TimeTactix Sprint logo
 * Ensures the logo fills the rounded square background edge-to-edge with no inner gutters
 * 
 * @param {string} size - Size class for container (e.g., "h-10 w-10", "h-16 w-16")
 * @param {string} className - Additional CSS classes for container
 * @param {function} onClick - Click handler for logo tile
 * @param {boolean} clickable - Whether the logo should have hover effects (default: false)
 * @param {string} cornerRadius - Tailwind border radius class (default: "rounded-lg")
 */
const LogoTile = ({ 
  size = "h-12 w-12", 
  className = "", 
  onClick = null, 
  clickable = false,
  cornerRadius = "rounded-lg"
}) => {
  const baseClasses = `${size} ${cornerRadius} overflow-hidden relative bg-slate-800 flex items-center justify-center`;
  const hoverClasses = clickable ? "hover:bg-slate-700 transition-colors cursor-pointer" : "";
  const combinedClasses = `${baseClasses} ${hoverClasses} ${className}`.trim();

  const logoElement = (
    <img 
      src="/branding/sprint-logo.png" 
      alt="TimeTactix Sprint" 
      role="img"
      className="absolute inset-0 w-full h-full object-cover"
      style={{ 
        objectFit: 'cover',
        objectPosition: 'center'
      }}
    />
  );

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={combinedClasses}
        aria-label="TimeTactix Sprint - Go to home"
      >
        {logoElement}
      </button>
    );
  }

  return (
    <div className={combinedClasses}>
      {logoElement}
    </div>
  );
};

export default LogoTile;